import { css } from '@emotion/react';
import { SasModal, theme } from 'common';
import { PropsWithChildren } from 'react';

const styles = {
  content: css`
    font-size: ${theme.fontSize.xs};
    margin-bottom: ${theme.spacing.xxl};
  `,
  button: css`
    display: flex;
    justify-content: flex-end;
  `,
};

type Props = PropsWithChildren<{
  title: string;
  buttonLabel: string;
  onClick: () => void;
  buttonDisabled?: boolean;
}>;

export function ErrorModal({ title, children, buttonLabel, onClick, buttonDisabled = false }: Props) {
  return (
    <SasModal open={true} showCloseButton={false}>
      <div>
        <h3>{title}</h3>
        <div css={styles.content}>{children}</div>
        <div css={styles.button}>
          <button disabled={buttonDisabled} onClick={onClick}>
            {buttonLabel}
          </button>
        </div>
      </div>
    </SasModal>
  );
}
